import { Form, message, Select, Input, Button } from 'antd';
import axiosInstance from '../../../utils/axiosInstance';

// import fetchWithAuth from '../../../utils/customFetch';

const { TextArea } = Input;
export default function CounterParty({ onClose, id }) {
    const [CounterPartyForm] = Form.useForm();

    const handleThirdPartySubmit = async (values) => {
        const updatedValues = {
            ...values,
            agreement_id: id,
        };
        try {
            const response = await axiosInstance.post(`/esign/third_party/`, updatedValues)
            message.success(response?.data?.message);
            // onClose();
            CounterPartyForm.resetFields();

        } catch (error) {
            console.log(error, 'updatedValues')
            message.error("Document Still pending for E-sign");
        }

        // const updatedValues = {
        //     ...values,
        //     agreement_id: id,
        // };
        // fetchWithAuth({
        //     method: 'POST',
        //     endpoint: '/api/v1/esign/third_party/',
        //     data: updatedValues,
        // }).then((response) => {
        //     message.success(response?.message);
        //     // onClose();
        //     CounterPartyForm.resetFields();
        // })
        //     .catch((error) => {
        //         console.log(error, 'updatedValues')
        //         message.error("Document Still pending for E-sign");
        //         //   onClose();
        //         // CounterPartyForm.resetFields();
        //     });
    };
    return (

        <Form form={CounterPartyForm} onFinish={handleThirdPartySubmit}>
            <h1 className="font-lg">Receiver's Email</h1>
            <Form.Item
                rules={[
                    {
                        validator: (_, value) => {
                            if (!value || value.length === 0) {
                                return Promise.reject("Please input at least one email!");
                            }
                            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            const invalidEmails = value.filter((email) => !emailRegex.test(email));
                            if (invalidEmails.length > 0) {
                                return Promise.reject(`Invalid email(s): ${invalidEmails.join(", ")}`);
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
                name="receiver" className="pt-1">
                <Select
                    mode="tags"
                    style={{ width: "100%" }}
                    placeholder="Enter receiver's email"
                    // onChange={handleEmailChange}
                    required
                ></Select>
            </Form.Item>
            <h1 className="font-lg">Remark</h1>

            <Form.Item
                rules={[{ required: true, message: 'Please input your Remark!' }]}
                name="remark" className="pt-1">
                <TextArea required />
            </Form.Item>

            <Button
                // htmlType="submit"
                onClick={() => { CounterPartyForm.submit() }}
                type="primary"
                className="!bg-[#4E36A3] !text-white !h-[40px] !w-[100px] hover:!bg-[#3b2a7a]"
            >
                Submit
            </Button>
        </Form>
    )
}
